var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"data-source-container",staticStyle:{"height":"-webkit-fill-available"}},[_c('div',{staticClass:"fw-light fs-14",domProps:{"innerHTML":_vm._s(_vm.data.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }